<template>
  <div class="row gy-0 gx-10">
    <!--begin::Col-->
    <div class="col-xl-12">
      <!--begin::General Widget 1-->
      <div class="mb-10">
        <div class="">
          <div class="card-header border-0">
            <h3 class="card-title align-items-center flex-column">
              <span class="card-label page-title fw-bolder fs-3 mb-1"
                >Order a Barrel</span
              >
              <!-- <span class="text-muted mt-1 fw-bold fs-7">Active Barrels</span> -->
            </h3>
          </div>
        </div>

        <OrderBarrelFormProgress v-model="formProgress" />

        <div class="spacer-y-10"></div>

        <!--begin::Tabs-->
        <div class="row">
          <div v-if="!isConsigneeSet" class="col-3"></div>
          <div :class="barrelDetailsSectionClass">
            <div class="card-body py-6">
              <div class="tab-content">
                <!--begin::Tap pane-->
                <label class="d-flex flex-stack cursor-pointer my-6">
                  <!--begin:Label-->
                  <span class="d-flex align-items-center me-2">
                    <span class="d-flex flex-column">
                      <h2>
                        <strong><u>Barrel Details</u> </strong>
                      </h2>
                    </span>
                    <!--end:Info-->
                  </span>
                </label>

                <!--begin::Svg Icon | path: icons/duotune/abstract/abs027.svg-->
                <BarrelIcon class="col" :capacity="order.capacity" />
                <dl class="row">
                  <dt class="col-6"><h5>Size</h5></dt>
                  <dd class="col-6">{{ order.barrelSize }}</dd>
                  <dt class="col-6"><h5>Delivery Method</h5></dt>
                  <dd class="col-6">
                    {{ order.deliveryMethod.toUpperCase() }}
                  </dd>
                  <dt class="col-6" v-if="isPickup">
                    <h5>Pickup Location</h5>
                  </dt>
                  <dd class="col-6" v-if="isPickup">
                    {{ order.pickupLocation }}
                  </dd>
                  <dt class="col-6" v-if="isDelivery">
                    <h5>Delivery Location</h5>
                  </dt>
                  <dd class="col-6" v-if="isDelivery">{{ deliveryAddress }}</dd>
                  <dt class="col-6"><h5>Remove Packaging</h5></dt>
                  <dd class="col-6">{{ removeSecondardPackaging }}</dd>
                  <dt class="col-6"><h5>Remove Retail Packaging</h5></dt>
                  <dd class="col-6">{{ removeRetailPackaging }}</dd>
                </dl>
              </div>
            </div>
          </div>
          <div v-if="!isConsigneeSet" class="col-3"></div>

          <div v-if="isConsigneeSet" class="card col-12 col-md mb-5">
            <div class="card-body py-6">
              <div class="tab-content">
                <!--begin::Tap pane-->

                <label class="d-flex flex-stack cursor-pointer my-6">
                  <!--begin:Label-->
                  <span class="d-flex align-items-center me-2">
                    <span class="d-flex flex-column">
                      <h2>
                        <strong><u>Recipient Details</u></strong>
                      </h2>
                    </span>
                    <!--end:Info-->
                  </span>
                </label>
                <dl class="row">
                  <dt class="col-5"><h5>Name</h5></dt>
                  <dd class="col-7">{{ consigneeName }}</dd>
                  <dt class="col-5"><h5>TRN</h5></dt>
                  <dd class="col-7">{{ consignee.trn }}</dd>
                  <dt class="col-5"><h5>Contact Number</h5></dt>
                  <dd class="col-7">{{ consignee.contactNumber }}</dd>
                  <dt class="col-5"><h5>Email</h5></dt>
                  <dd class="col-7">{{ consignee.email }}</dd>
                  <dt class="col-5"><h5>Address</h5></dt>
                  <dd class="col-7">{{ consigneeAddress }}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div
            class="card col-md mr-5 mb-5"
            @click="paymentConfig.paymentMethod = fullPaymentSelector"
          >
            <div class="card-body py-6">
              <div class="tab-content">
                <!--begin::Tap pane-->

                <label class="d-flex flex-stack cursor-pointer my-6">
                  <!--begin:Label-->
                  <span class="d-flex align-items-center me-2">
                    <span
                      class="
                        form-check form-check-custom form-check-solid
                        is-valid
                      "
                    >
                      <input
                        class="form-check-input"
                        type="radio"
                        v-model="paymentConfig.paymentMethod"
                        :value="fullPaymentSelector"
                      />
                    </span>
                    <span class="d-flex flex-column">
                      <h2>
                        <strong><u>Full Payment</u></strong>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          v-b-tooltip.hover
                          title="Pay all costs upfront; where applicable, additional fees will be assessed before delivery"
                          data-bs-original-title=""
                          aria-label="Full Payment"
                        ></i>
                      </h2>
                    </span>
                    <!--end:Info-->
                  </span>
                </label>

                <dl class="row">
                  <dt class="col-9">
                    <h5>{{ order.barrelSize }} barrel:</h5>
                  </dt>
                  <dd class="col-3">${{ order.barrelCost }} USD</dd>
                  <dt class="col-9"><h5>Shipping:</h5></dt>
                  <dd class="col-3">${{ order.shippingCost }} USD</dd>
                  <dt class="col-9"><h5>Duty & Clearance:</h5></dt>
                  <dd class="col-3">
                    ${{ additionalCosts.clearanceCost }} USD
                  </dd>
                  <dt v-if="isDelivery" class="col-9"><h5>Delivery:</h5></dt>
                  <dd v-if="isDelivery" class="col-3">
                    ${{ deliveryCost }} USD
                  </dd>
                  <dt v-if="isDelivery" class="col-9"><h5>GCT:</h5></dt>
                  <dd v-if="isDelivery" class="col-3">
                    ${{ deliveryCostGct }} USD
                  </dd>
                </dl>
              </div>
            </div>
          </div>
          <div
            class="card col-md mb-5"
            @click="paymentConfig.paymentMethod = partPaymentSelector"
          >
            <div class="card-body py-6">
              <div class="tab-content">
                <!--begin::Tap pane-->

                <label class="d-flex flex-stack cursor-pointer my-6">
                  <!--begin:Label-->
                  <span class="d-flex align-items-center me-2">
                    <span
                      class="
                        form-check form-check-custom form-check-solid
                        is-valid
                      "
                    >
                      <input
                        class="form-check-input"
                        type="radio"
                        v-model="paymentConfig.paymentMethod"
                        :value="partPaymentSelector"
                      />
                    </span>
                    <span class="d-flex flex-column">
                      <h2>
                        <strong><u>Part Payment</u></strong>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          v-b-tooltip.hover
                          title="Pay for the barrel now then duty and clearance later."
                          data-bs-original-title=""
                          aria-label="Full Payment"
                        ></i>
                      </h2>
                    </span>
                    <!--end:Info-->
                  </span>
                </label>

                <dl class="row">
                  <dt class="col-9">
                    <h5>{{ order.barrelSize }} barrel:</h5>
                  </dt>
                  <dd class="col-3">${{ order.barrelCost }} USD</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-3"></div>
          <div class="card col-6 col-md mb-5">
            <div class="card-body py-6">
              <div class="tab-content">
                <!--begin::Tap pane-->

                <label class="d-flex flex-stack cursor-pointer my-6">
                  <!--begin:Label-->
                  <span class="d-flex align-items-center me-2">
                    <span class="d-flex flex-column">
                      <h2>
                        <strong><u>Discount Code</u></strong>
                      </h2>
                    </span>
                    <!--end:Info-->
                  </span>
                </label>
                <div class="row">
                  <div class="col">
                    <input
                      type="text"
                      class="
                        form-control form-control-lg form-control-solid
                        mt-2
                      "
                      v-model="enteredCode"
                    />
                  </div>
                  <div class="col">
                    <button
                      @click="verifyPromoCode"
                      :class="verifyBtnClass"
                      :disabled="verifyLoading"
                    >
                      <v-progress-circular
                        v-if="verifyLoading"
                        indeterminate
                        color="white"
                        class="ml-2 mr-2"
                        size="26"
                        width="2"
                      ></v-progress-circular>
                      <span v-if="!verifyLoading">Verify</span>
                    </button>
                  </div>
                </div>
                <div v-if="isPromoCodeSet" class="row">
                  <div class="col-11">
                    <dl class="row">
                      <dt class="col-6">
                        <h5>{{ paymentConfig.promoCode.name }}</h5>
                      </dt>
                      <dd class="col-6">
                        {{ formatPromoCodeAmount(paymentConfig.promoCode) }}
                      </dd>
                    </dl>
                  </div>
                  <div class="col-1">
                    <button @click="resetPromoCode">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
                          stroke="#060606"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                        <path
                          d="M14 8L8 14"
                          stroke="#060606"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                        <path
                          d="M8 8L14 14"
                          stroke="#060606"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-3"></div>
        </div>

        <div class="row">
          <div class="col">
            <h2>Total: ${{ total }} USD</h2>
          </div>
        </div>
        <div class="row">
          <div class="card plain-card col align-center col-xl-4">
            <button
              class="btn btn-primary fw-bold px-6 py-5 w-100 mb-4 mt-6"
              data-bs-toggle="modal"
              data-bs-target="#kt_modal_create_app"
              @click="$emit('previous')"
            >
              <svg
                width="22"
                height="23"
                viewBox="0 0 22 23"
                fill="none"
                style="transform: scale(-1, 1)"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.9775 21.5121C16.4009 21.5121 20.7975 17.1156 20.7975 11.6921C20.7975 6.26869 16.4009 1.87213 10.9775 1.87213C5.55403 1.87213 1.15747 6.26869 1.15747 11.6921C1.15747 17.1156 5.55403 21.5121 10.9775 21.5121Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M10.9775 15.6201L14.9055 11.6921L10.9775 7.7641"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M7.04956 11.6921H14.9056"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
              Previous
            </button>
          </div>
          <div class="card plain-card col align-center col-xl-4">
            <button
              :class="saveBtnClass"
              data-bs-toggle="modal"
              data-bs-target="#kt_modal_create_app"
              @click="$emit('save')"
            >
              <span
                v-if="saveOrderLoading"
                class="spinner-border spinner-border-md align-middle ms-2"
              ></span>
              Save for later
            </button>
          </div>
          <div
            v-if="finalScreen"
            class="card plain-card col align-center col-xl-4"
          >
            <button
              :class="orderBtnClass"
              data-bs-toggle="modal"
              data-bs-target="#kt_modal_create_app"
              @click="$emit('pay')"
            >
              Place Order
              <span
                v-if="placeOrderLoading"
                class="spinner-border spinner-border-md align-middle ms-2"
              ></span>
              <svg
                v-if="!placeOrderLoading"
                width="22"
                height="23"
                viewBox="0 0 22 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.9775 21.5121C16.4009 21.5121 20.7975 17.1156 20.7975 11.6921C20.7975 6.26869 16.4009 1.87213 10.9775 1.87213C5.55403 1.87213 1.15747 6.26869 1.15747 11.6921C1.15747 17.1156 5.55403 21.5121 10.9775 21.5121Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M10.9775 15.6201L14.9055 11.6921L10.9775 7.7641"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M7.04956 11.6921H14.9056"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
          </div>
          <div v-else class="card plain-card col align-center col-xl-4">
            <button
              @click="$emit('next')"
              class="btn fw-bold px-6 py-5 w-100 mb-4 mt-6 btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#kt_modal_create_app"
            >
              Next
              <svg
                width="22"
                height="23"
                viewBox="0 0 22 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.9775 21.5121C16.4009 21.5121 20.7975 17.1156 20.7975 11.6921C20.7975 6.26869 16.4009 1.87213 10.9775 1.87213C5.55403 1.87213 1.15747 6.26869 1.15747 11.6921C1.15747 17.1156 5.55403 21.5121 10.9775 21.5121Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M10.9775 15.6201L14.9055 11.6921L10.9775 7.7641"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M7.04956 11.6921H14.9056"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
          </div>
        </div>
        <!-- mb-10 -->
        <!--end::General Widget 1-->
      </div>
    </div>
    <!--end::Col-->
    <!--begin::Col-->

    <!--end::Col-->
  </div>
</template>

<script>
import Vue from "vue";
import BarrelIcon from "@/components/BarrelIcon.vue";
import { error } from "@/services/LoggerService";
import {
  ApiService,
  PromoCodeDiscountType,
  PaymentOption,
} from "@/services/ApiService";
import OrderBarrelFormProgress from "@/components/OrderBarrelFormProgress.vue";
import { roundOffFigure } from "@/services/CommonService";

export default Vue.extend({
  name: "OrderBarrelSummary",
  components: { BarrelIcon, OrderBarrelFormProgress },
  data() {
    return {
      paymentConfig: {
        promoCode: {},
        paymentMethod: PaymentOption.UPFRONT,
      },
      enteredCode: "",
      verifyLoading: false
    };
  },
  props: {
    placeOrderLoading: {
      type: Boolean,
      default: false,
    },
    saveOrderLoading: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default: () => ({}),
    },
    consignee: {
      type: Object,
      default: () => ({ address: {} }),
    },
    additionalCosts: {
      type: Object,
      default: () => ({}),
    },
    finalScreen: {
      type: Boolean,
      default: true,
    },
    formProgress: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },
  watch: {
    paymentConfig: {
      handler(value) {
        this.$emit("update:paymentConfig", value);
      },
      deep: true,
    },
  },
  computed: {
    isPickup() {
      return this.order.deliveryMethod.toUpperCase() === "PICKUP";
    },
    isDelivery() {
      return this.order.deliveryMethod.toUpperCase() === "DELIVERY";
    },
    deliveryAddress() {
      return `${this.order.deliveryAddress.line1} ${
        this.order.deliveryAddress.line2 ?? ""
      }, ${this.order.deliveryAddress.town} ${
        this.order.deliveryAddress.parish
      }`;
    },
    barrelDetailsSectionClass() {
      if (this.isConsigneeSet) {
        return "card col-12 col-md mr-5 mb-5";
      }

      return "card col-6 col-md mr-5 mb-5";
    },
    isConsigneeSet() {
      return !!this.consignee.firstName;
    },
    consigneeName() {
      return `${this.consignee.firstName} ${this.consignee.lastName}`;
    },
    consigneeAddress() {
      return `${this.consignee.address.line1} ${this.consignee.address.line2}, ${this.consignee.address.town} ${this.consignee.address.parish}`;
    },
    removeSecondardPackaging() {
      return this.order.removeSecondaryPackaging ? "Yes" : "No";
    },
    removeRetailPackaging(){
      return this.order.removeRetailPackaging ? "Yes" : "No";
    },
    orderBtnClass() {
      const defautClass = "btn fw-bold px-6 py-5 w-100 mb-4 mt-6";
      if (this.$props.placeOrderLoading)
        return `${defautClass} btn-secondary disabled`;

      return `${defautClass} btn-primary`;
    },
    saveBtnClass() {
      const defautClass = "btn fw-bold px-6 py-5 w-100 mb-4 mt-6";
      if (this.$props.saveOrderLoading)
        return `${defautClass} btn-secondary disabled`;

      return `${defautClass} btn-primary`;
    },
    verifyBtnClass() {
      const disabled = !this.enteredCode;

      const defautClass = "btn fw-bold px-6 py-5";
      if (disabled) return `${defautClass} btn-secondary disabled`;

      return `${defautClass} btn-primary`;
    },
    isPromoCodeSet() {
      return (
        !!this.paymentConfig.promoCode?.name &&
        !!this.paymentConfig.promoCode?.amount
      );
    },
    deliveryCost() {
      return this.order.deliveryCost ?? 0;
    },
    deliveryCostGct() {
      const deliveryGctPercentage =
        this.additionalCosts.deliveryGctPercentage ?? 0;
      const gct = (this.deliveryCost * deliveryGctPercentage) / 100;
      return roundOffFigure(gct, 2);
    },
    fullPaymentSelector() {
      return PaymentOption.UPFRONT;
    },
    fullPaymentSubTotal() {
      let total =
        this.order.barrelCost +
        this.order.shippingCost +
        this.additionalCosts.clearanceCost;

      return total;
    },
    partPaymentSelector() {
      return PaymentOption.STAGES;
    },
    partPaymentTotal() {
      return this.order.barrelCost;
    },
    total() {
      let total = this.fullPaymentSubTotal;
      try {
        let subtotal = total;
        if (this.paymentConfig.paymentMethod === PaymentOption.STAGES) {
          subtotal = this.partPaymentTotal;
        }

        const discount = this.calculateDiscount(
          subtotal,
          this.paymentConfig.promoCode
        );

        let discountedSubtotal = subtotal - discount;

        if (discountedSubtotal < 0) {
          discountedSubtotal = 0;
        }

        total = discountedSubtotal;

        if (this.paymentConfig.paymentMethod === PaymentOption.UPFRONT) {
          total = total + this.deliveryCost +this.deliveryCostGct;
        }

        return total;
      } catch (e) {
        error(e);
      }

      return total;
    },
    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    },
  },
  methods: {
    formatPromoCodeAmount(promoCode) {
      if (promoCode.type === PromoCodeDiscountType.Percentage) {
        return `-${promoCode.amount}%`;
      }

      return `-$${promoCode.amount}`;
    },
    calculateDiscount(subtotal, promoCode) {
      try {
        const amount = this.paymentConfig.promoCode?.amount ?? 0;
        if (amount <= 0) {
          return 0;
        }

        if (promoCode.type === PromoCodeDiscountType.Fixed) {
          return amount;
        }

        const percentageDiscount = (subtotal * amount) / 100;

        return roundOffFigure(percentageDiscount, 2);
      } catch (e) {
        error(e);
      }

      return 0;
    },
    promoCodeVerificationMethod(input){
      if (this.isLoggedIn) {
          return ApiService.Instance.verifyCustomerPromoCode(input);
      }

      return ApiService.Instance.verifyPromoCode(input);
    },
    async verifyPromoCode() {
      try {
        this.verifyLoading = true;
        if (!this.enteredCode) {
          return;
        }

        const result = await this.promoCodeVerificationMethod({
          code: this.enteredCode,
        });
        if (!result?.isSuccessful || !result.discount) {
          const reason = result?.reason ?? "Discount Code is Invalid";
          this.showNotification(reason, "error");
          return;
        }
        this.paymentConfig.promoCode = result.discount;
        this.paymentConfig.promoCode.code = this.enteredCode;
        this.showNotification("Discount Code Applied", "success");
      } catch (e) {
        error(e);
        this.showNotification("Discount Code is Invalid", "error");
      } finally {
        this.verifyLoading = false;
      }
    },
    showNotification(message, snackbarType) {
      this.$emit("show:notification", { message, snackbarType });
    },
    resetPromoCode() {
      this.paymentConfig.promoCode = {};
    },
  },
});
</script>

<style></style>
